export default class StreamQueueManager {
    constructor(maxActiveStreams = 3) {
        this.maxActiveStreams = maxActiveStreams;
        this.activeStreams = new Map(); // Map of active streams
        this.streamEvents = new Map(); // Map to store current event for each stream
    }

    addStream(messageId, streamController) {
        // If we're at max capacity, cancel oldest stream
        if (this.activeStreams.size >= this.maxActiveStreams) {
            const oldestMessageId = this.activeStreams.keys().next().value;            
            this.cancelStream(oldestMessageId);
        }

        this.activeStreams.set(messageId, streamController);
        this.streamEvents.set(messageId, ""); // Initialize event for this stream
    }

    setCurrentEvent(messageId, event) {
        this.streamEvents.set(messageId, event);
    }

    getCurrentEvent(messageId) {
        return this.streamEvents.get(messageId) || "";
    }

    cancelStream(messageId) {  
        const controller = this.activeStreams.get(messageId);  
        if (controller) {  
            controller.abort();  
            this.removeStream(messageId);  
        }  
    }

    removeStream(messageId) {  
        this.activeStreams.delete(messageId);  
        this.streamEvents.delete(messageId);  
    }

    cancelAllActiveStreams() {
        for (const [, controller] of this.activeStreams) {
            controller.abort();
        }
        this.activeStreams.clear();
        this.streamEvents.clear();
    }

    getActiveStreams() {
        return Array.from(this.activeStreams.keys());
    }
}
